import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const SafetyEquipment = ({ selectedEquipment, onEquipmentToggle, equipmentList, errors }) => {
  const requiredEquipment = equipmentList?.filter(eq => eq?.required);
  const optionalEquipment = equipmentList?.filter(eq => !eq?.required);

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
          <Icon name="Shield" size={20} color="var(--color-success)" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Required Safety Equipment</h2>
          <p className="text-sm text-muted-foreground">Select all safety equipment that will be used</p>
        </div>
      </div>
      <div className="space-y-6">
        {requiredEquipment?.length > 0 && (
          <div>
            <div className="flex items-center gap-2 mb-3 pb-2 border-b border-border">
              <Icon name="ShieldCheck" size={18} color="var(--color-error)" />
              <h3 className="font-medium text-foreground">Mandatory Equipment</h3>
              <span className="text-xs text-error ml-auto">Required</span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pl-4">
              {requiredEquipment?.map((equipment) => (
                <Checkbox
                  key={equipment?.id}
                  label={equipment?.name}
                  description={equipment?.description}
                  checked={selectedEquipment?.includes(equipment?.id)}
                  onChange={(e) => onEquipmentToggle(equipment?.id, e?.target?.checked)}
                  required
                />
              ))}
            </div>
          </div>
        )}

        {optionalEquipment?.length > 0 && (
          <div>
            <div className="flex items-center gap-2 mb-3 pb-2 border-b border-border">
              <Icon name="Package" size={18} color="var(--color-primary)" />
              <h3 className="font-medium text-foreground">Additional Equipment</h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pl-4">
              {optionalEquipment?.map((equipment) => (
                <Checkbox
                  key={equipment?.id}
                  label={equipment?.name}
                  description={equipment?.description}
                  checked={selectedEquipment?.includes(equipment?.id)}
                  onChange={(e) => onEquipmentToggle(equipment?.id, e?.target?.checked)}
                />
              ))}
            </div>
          </div>
        )}
      </div>
      {errors?.equipment && (
        <p className="mt-4 text-sm text-error">{errors?.equipment}</p>
      )}
      <div className="mt-6 bg-accent/5 border border-accent/20 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={18} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <div className="text-sm text-muted-foreground">
            <p className="font-medium text-foreground mb-1">Equipment Verification</p>
            <p>All selected equipment must be inspected and verified before work begins. Equipment inspection records will be attached to this permit.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafetyEquipment;